export const Actions: React.FC<{ children?: React.ReactNode }> = ({
	children,
}) => <>{children}</>;
